export const AUTHENTICATED_WALLET_STATE_COOKIE_NAME =
  'authenticatedWalletState';
export const AUTHENTICATED_WALLET_ID_STATE = 'walletId';
export const AUTHENTICATED_WALLET_INFO_STATE = 'walletInfo';
export const ACCESS_TOKEN_COOKIE_NAME = 'accessToken';
export const ANIMATION_COOKIE_NAME = 'logoAnimation';
export const AUTHENTICATED_SIGNATURE_STATE = 'signature';
